import React, { useState } from 'react'
import RiveComponent, { RiveFit } from '../../components/RiveComponent'
import RenderHTML from '../../components/ui-components/RenderHTML'

interface OTPLoadingStateProps {
  isOTPVerificationLoading: boolean
  isOTPVerficationSuccess: boolean
}

export const OTPLoadingState: React.FC<OTPLoadingStateProps> = ({
  isOTPVerificationLoading,
  isOTPVerficationSuccess
}) => {
  const [isRiveError, setIsRiveError] = useState(false)
  if (!isOTPVerificationLoading && !isOTPVerficationSuccess) return null

  if (isRiveError) {
    return (
      <BackUpOTPLoadingState
        isOTPVerificationLoading={isOTPVerificationLoading}
        isOTPVerficationSuccess={isOTPVerficationSuccess}
      />
    )
  }

  return (
    <div className='flex gap-[6px] items-center ml-1 w-[82px]'>
      <RiveComponent
        src={`/rives/mf-execution/otp_loader.riv`}
        stateMachines={isOTPVerficationSuccess ? 'verified' : 'verifying'}
        fit={RiveFit.CONTAIN}
        onError={() => setIsRiveError(true)}
      />
    </div>
  )
}

export const BackUpOTPLoadingState: React.FC<OTPLoadingStateProps> = ({
  isOTPVerificationLoading,
  isOTPVerficationSuccess
}) => {
  if (!isOTPVerificationLoading && !isOTPVerficationSuccess) return null

  if (isOTPVerficationSuccess) {
    return (
      <div className=' flex gap-[6px] items-center ml-2'>
        <div className='inline-block mt-[1px]'>
          <RenderHTML innerHTMLText={VerifiedIcon} />
        </div>
        <span className='text-[13px] font-[500] text-[#1470CC]'>Verified</span>
      </div>
    )
  }

  return (
    <div className='flex gap-[6px] items-center ml-2'>
      <div className='inline-block mt-[1px]'>
        <RenderHTML innerHTMLText={LoadingSpinner} />
      </div>
      <span className='text-[13px] font-[500] text-[#1470CC]'>Verifying</span>
    </div>
  )
}

const LoadingSpinner = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" class="animate-spin">
  <path d="M9.25 5C9.25 5.81435 9.01604 6.61156 8.57595 7.29676C8.13586 7.98196 7.50818 8.52629 6.7676 8.86498C6.02702 9.20368 5.20472 9.32247 4.39856 9.20723C3.59241 9.09199 2.83633 8.74756 2.22031 8.21493C1.60428 7.68231 1.15426 6.98392 0.923772 6.20286C0.693289 5.4218 0.692058 4.59097 0.920224 3.80923C1.14839 3.0275 1.59635 2.32777 2.21079 1.79332C2.82523 1.25887 3.58028 0.912206 4.38609 0.794573" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round"/>
</svg>`

const VerifiedIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
  <path d="M1 4.5L4.21429 8L10 1" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
